import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=0496d312&functional=true"
var script = {}
import style0 from "./ExternalLink.vue?vue&type=style&index=0&id=0496d312&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports